import { HardwareModels } from "types/productTypes";

export const DPVR_IDENTIFIERS = ["deepoon", "dpvr"];
export const DPVR_MODEL_CODES = ["p2"];
export const DPVR_PACKAGE_PREFIXES = ["com.dpvr.", "com.deepoon."];

const PICO_NEO_3_PRODUCT_NAME = "Pico Neo 3 Pro Eye";
const PICO_SWAN_IDENTIFIER = "swan";
const HTC_VENDOR = "htc";
const HTC_FOCUS_MODEL_IDENTIFIER = "vive focus";

export interface AdbHardwareProps {
  pxrProductName: string;
  manufacturer: string;
  model: string;
  brand?: string;
  device?: string;
  name?: string;
  packages?: string;
}

const normalize = (value?: string): string => (value || "").trim().toLowerCase();

const getVendorFields = (props: AdbHardwareProps): string[] =>
  [props.manufacturer, props.model, props.brand, props.device, props.name].map(normalize);

function isPicoSwanDevice(props: AdbHardwareProps): boolean {
  return getVendorFields(props).some((f) => f.includes(PICO_SWAN_IDENTIFIER));
}

function isHtcDevice(props: AdbHardwareProps): boolean {
  return (
    normalize(props.manufacturer) === HTC_VENDOR ||
    normalize(props.brand) === HTC_VENDOR ||
    normalize(props.model).includes(HTC_FOCUS_MODEL_IDENTIFIER)
  );
}

function isDpvrDevice(props: AdbHardwareProps): boolean {
  const vendorFields = getVendorFields(props);

  if (DPVR_IDENTIFIERS.some((identifier) => vendorFields.some((f) => f.includes(identifier)))) {
    return true;
  }

  if (DPVR_MODEL_CODES.some((code) => vendorFields.includes(code))) {
    return true;
  }

  const packages = normalize(props.packages);
  return DPVR_PACKAGE_PREFIXES.some((prefix) => packages.includes(prefix));
}

export function mapAdbPropsToHardwareModel(props: AdbHardwareProps): HardwareModels {
  if (props.pxrProductName === PICO_NEO_3_PRODUCT_NAME) {
    return HardwareModels.PicoNeo3ProEye;
  }

  if (isPicoSwanDevice(props)) {
    return HardwareModels.PicoSwan;
  }

  if (isHtcDevice(props)) {
    return HardwareModels.HtcFocusVision;
  }

  if (isDpvrDevice(props)) {
    return HardwareModels.Dpvr;
  }

  return HardwareModels.Pico4Enterprise;
}

export function needsVendorPackageProbe(props: AdbHardwareProps): boolean {
  return (
    !normalize(props.pxrProductName) &&
    mapAdbPropsToHardwareModel(props) === HardwareModels.Pico4Enterprise
  );
}
